const theme = {
  black: {
    default: '#0e1111',
  },
  white: {
    default: '#fefefe',
  },
  grey: {
    default: '#e8e8e8',
  },
  boxShadows: {
    default: '0px 0px 29px -16px rgba(0,0,0,0.75)',
  },
};

export default theme;
